import { PREFIX_COVERHOLDER } from "@/api/Model/ProductOwnerModel";
import AbstractProduct from "../Product";

class Product extends AbstractProduct {
  static getResourceEndpoint() {
    return PREFIX_COVERHOLDER + '/products-ipr';
  }
}

export default Product;
